import Icon from '../components/Icon.vue'

Icon.register({
  'user-clock': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M496 224c79.6 0 144 64.4 144 144s-64.4 144-144 144-144-64.4-144-144 64.4-144 144-144zM560 374.3v-12.6c0-5.3-4.4-9.7-9.7-9.7h-38.3v-54.3c0-5.3-4.4-9.7-9.7-9.7h-12.6c-5.3 0-9.7 4.4-9.7 9.7v76.6c0 5.3 4.4 9.7 9.7 9.7h60.6c5.3 0 9.7-4.4 9.7-9.7zM320 368c0 59.5 29.8 112.1 75.1 144h-347.1c-26.5 0-48-21.5-48-48v-41.6c0-74.2 60.2-134.4 134.4-134.4h16.7c22.3 10.2 46.9 16 72.9 16s50.7-5.8 72.9-16h16.7c8.4 0 16.6 1 24.6 2.5-11.5 23.4-18.2 49.7-18.2 77.5zM224 256c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-clock.js
// module id = 2059
// module chunks = 0